import axios from "axios";
import store from "redux/Store";
import { v4 as uuidv4 } from "uuid";
import { validateUniqueValue } from "util/validations/ClearanceWizardValidation";
import { __getStatus, __getMessageId, __getNotes } from "_clearance/utils/utils";
import { clearanceFormType } from "../Types";

module = "/cueSheetFormContentNeo";
export const actionTypes = {
  LOADING: "LOADING" + module,
  LOAD: "LOAD" + module,
  ERROR: "ERROR" + module,
  FOCUS_ITEM: "FOCUS_ITEM" + module,
  SELECT_ITEMS: "SELECT_ITEMS" + module,
  POSTING: "POSTING" + module,
  POST_OK: "POSTOK" + module,
  POST_OK_LOCAL: "POST_OK_LOCAL" + module,
  POST_ERROR_LOCAL: "POST_ERROR_LOCAL" + module,
  POST_ERROR: "POST_ERROR" + module,
  REFRESH_ITEMS: "REFRESH_ITEMS" + module,
  REFRESH_CF: "REFRESH_CF" + module,
  EDITING: "EDITING" + module,
  OPENWIZARD: "OPENWIZARD" + module,
  PREVIEW_TAB: "PREVIEW_TAB" + module,


  LOAD_CFTRACKS: "LOAD_CFTRACKS" + module,
  LOADING_CFTRACKS: "LOADING_CFTRACKS" + module,
  SET_TLOOKUP: "SET_TLOOKUP" + module,
  SET_CUESHEET: "SET_CUESHEET" + module,
  ADD_CUE_DATA: "ADD_CUE_DATA" + module,
  REMOVE_CUE_DATA: "REMOVE_CUE_DATA" + module,
  ADD_VALUE: "ADD_VALUE" + module,
  SAVE_DATA: "SAVE_DATA" + module,
  SAVING_DATA: "SAVING_DATA" + module,
  SAVING_DATA_LOCAL: "SAVING_DATA_LOCAL" + module,
  LOAD_TRACKS: "LOAD_TRACKS" + module,
  LOADING_TRACKS: "LOADING_TRACKS" + module,
  ERROR_TRACKS: "ERROR_TRACKS" + module,
  QUERY: "QUERY" + module,
  SET_STATUSES: "SET_STATUSES" + module,
  SET_PARAMETERS: "SET_PARAMETERS" + module,
  SET_SESSIONID: "SET_SESSIONID" + module,
  CLEAR_ERRORS: "CLEAR_ERRORS" + module,
  ADD_TIMECODE: "ADD_TIMECODE" + module,
  SET_INVALID_TIMECODE: "SET_INVALID_TIMECODE" + module,
  SAVE_SUCCESS: "SAVE_SUCCESS" + module,
  SORT_BY_TRACKTITLE: "SORT_BY_TRACKTITLE" + module,
  SORT_BY_TIMECODE: "SORT_BY_TIMECODE" + module,
  ADD_VALUE_TIMECODE_ADDITIONAL: "ADD_VALUE_TIMECODE_ADDITIONAL" + module,
  ADD_CUE_DATA_TIMECODE_SORT: "ADD_CUE_DATA_TIMECODE_SORT" + module,
  ADD_TIMECODE_ADDITIONAL: "ADD_TIMECODE_ADDITIONAL" + module,
  REMOVE_SUB_CUE_DATA: "REMOVE_SUB_CUE_DATA" + module,
  RE_SORT_TIMECODE: "RE_SORT_TIMECODE" + module,
  SET_INVALID_TIMECODE_CHILD: "SET_INVALID_TIMECODE_CHILD" + module,
  SET_SORTVALUE: "SET_SORTVALUE" + module,
  RE_SORT_TIMECODE_UPDATE_DONE: "RE_SORT_TIMECODE_UPDATE_DONE" + module,

};

export const getCFContent = (id) =>
  new Promise(function (resolve, reject) {
    const {
      user: {
        credentials: { orgID },
      },
    } = store.getState();

    axios
      .get(`${orgID}/mllic/formcontent/${id}`, {
        headers: { orgid: orgID },
      })
      .then((res) => {
        resolve(res?.data?.results ? res.data.results : null);
      })
      .catch((err) => {
        resolve(null);
      });
  });

export const setQuery = (query, done = null) => (dispatch) => {
  dispatch({
    type: actionTypes.QUERY,
    payload: query,
  });

  if (done) done();
};









export const refreshitems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.REFRESH_ITEMS,
    payload: items,
  });
};
export const setSortVal = (val) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_SORTVALUE,
    payload: val,
  });
};

export const refreshEdit = (editing) => (dispatch) => {
  dispatch({
    type: actionTypes.EDITING,
    payload: editing,
  });
};


export const selectItems = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SELECT_ITEMS,
    payload: items,
  });
};

export const focusItem = (item) => (dispatch) => {
  dispatch({
    type: actionTypes.FOCUS_ITEM,
    payload: item,
  });
};

const _initCFItems = (res, sessionid, done, dispatch) => {
  const {
    orgRuntime: {
      runtime: {
        _trackFields: _trackFields,

      }
    },
    cueSheetFormContentNeo: { query },
  } = store.getState();
  let items = [];

  dispatch({
    type: actionTypes.LOAD,
    payload: { data: res, items: items },
  });

  let nQuery = { ...query, clearanceFormId: res.id, selectedMasterFormId: res.selectedMasterFormId }
  if (res && (res.clearanceFormType == clearanceFormType.PROGRAMMING || res.clearanceFormType == clearanceFormType.SPORT)) {
    dispatch({
      type: actionTypes.SET_SORTVALUE,
      payload: "byTrackTitle",
    });
    nQuery = { ...nQuery, orderBy: 'trackDetails.trackTitle', order: 'asc' };
  }
  dispatch(setQuery(nQuery, () => {
    dispatch(searchCfItems(nQuery, sessionid));
  }));

  if (done) done({ data: res, items: items }, null);
};

export const clearErrors = (param = "", done) => (dispatch) => {
  dispatch({
    type: actionTypes.CLEAR_ERRORS,
    payload: null,
  });
};

export const loadcf = (id, sessionId, cueSheetId, done = null) => (dispatch) => {

  const {
    cueSheetNeo,
  } = store.getState();

  const tId = uuidv4();
  dispatch({
    type: actionTypes.LOADING,
  });

  axios
    .get(`/neocuesheet/cuesheetCfContent/${cueSheetId}/${id}`, {
      headers: {
        tid: tId,
        sessionid: localStorage.getItem('sessionid') || sessionId,
        workspaceid: localStorage.getItem('workspaceid'),
        usertoken: localStorage.getItem('neo_id_token'),
        // broadcasterIssuedId: "CC_GEG444035_125afac7-e25c-4b2f-bc28-79695675a6db" // to be fixed
        // broadcasterIssuedId: "P2254754" // to be fixed
      },
    })
    .then((res) => {
      if (res.data.tid === tId) {
        dispatch({
          type: actionTypes.SET_CUESHEET,
          payload: { ...res.data.cueSheet, ...res.data.cueSheet.cuesheet_header },
        });
        dispatch({
          type: actionTypes.SET_STATUSES,
          payload: res.data._statuses,
        });
        dispatch({
          type: actionTypes.SET_PARAMETERS,
          payload: res.data._parameters,
        });
        dispatch({
          type: actionTypes.SET_SESSIONID,
          payload: sessionId,
        });
        return _initCFItems(res.data.results, sessionId, done, dispatch);
      }
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR,
        payload: { e: err },
      });
      if (done) done(null, err);
    });
};

export const searchCfItems = (query, sessionid) => (dispatch) => {

  const {
    orgRuntime: {
      runtime: {
        _trackFields: _trackFields,

      }
    },
    cueSheetFormContentNeo: { query: { page, size, trackIds: qTrackIds, selectedEpisode }, editing, query },
    cueSheetNeo: { session },
  } = store.getState();


  dispatch({
    type: actionTypes.LOADING_TRACKS,
  });


  axios
    .post(`neocuesheet/tracks/search`, {
      ...query,
      ...(editing.skyMigrated ? { isMigrated: true } : {})
    }, {
      headers: {
        sessionid: localStorage.getItem('sessionid'),
        usertoken: localStorage.getItem('neo_id_token')
      },
    })
    .then((res) => {
      //reorder clearance tracks if there are replaced tracks
      if ((editing.clearanceFormType === clearanceFormType.PROGRAMMING || editing.clearanceFormType === clearanceFormType.NEWS) && editing.clearance.replacedTracks) {
        const replacedTracks = editing.clearance.replacedTracks;
        const resultList = res.data.results || [];
        const newOrder = [];
        const movedIndexes = new Set();

        for (let i = 0; i < resultList.length; i++) {
          const currentItem = resultList[i];
          const currentTrackId = currentItem.trackDetails?.id;
          if (movedIndexes.has(i) || Object.values(replacedTracks).includes(currentTrackId)) continue;

          if (currentTrackId && replacedTracks[currentTrackId]) {
            const replacementTrackId = replacedTracks[currentTrackId];

            const replacementIndex = resultList.findIndex((item, idx) => {
              return !movedIndexes.has(idx) && item.trackDetails?.id === replacementTrackId;
            });

            if (replacementIndex !== -1) {
              newOrder.push(resultList[replacementIndex], currentItem);
              movedIndexes.add(replacementIndex);
            }
          } else {
            newOrder.push(currentItem);
          }
        }
        res.data.results = newOrder;

      }

      dispatch({
        type: actionTypes.LOAD_TRACKS,
        payload: {
          items: res.data.results,
          totalItems: res.data.total
        }
      });

      dispatch({
        type: actionTypes.FOCUS_ITEM,
        payload: res.data.results[0],
      });


    })
    .catch((err) => {
      dispatch({
        type: actionTypes.ERROR_TRACKS,
        payload: "Error loading Tracks.."
      });
    });

}





export const onClickAddCueData = (id, value) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_CUE_DATA,
    // payload: id,
    payload: { id: id, value: value },
  });
};
export const onHandleAddCueDataTcSort = (id, value, parentid) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_CUE_DATA_TIMECODE_SORT,
    payload: { id: id, value: value, parentid: parentid },
  });
};
export const onClickRemoveCueData = (id, index) => (dispatch) => {
  const {
    cueSheetFormContentNeo: { selectedItem, items, timeCodeSorting }
  } = store.getState();
  dispatch({
    type: actionTypes.REMOVE_CUE_DATA,
    payload: { id: id, index: index },
  });

  if (timeCodeSorting) {
    sortbyTimeCode();
    setTimeout(() => {
      dispatch({
        type: actionTypes.FOCUS_ITEM,
        payload: items[0],
      });
    }, 1000);
  }

};
export const onHandleRemoveSubCueData = (id, parentindex, subindex) => (dispatch) => {
  const {
    cueSheetFormContentNeo: { selectedItem, items, timeCodeSorting }
  } = store.getState();
  dispatch({
    type: actionTypes.REMOVE_SUB_CUE_DATA,
    payload: { id: id, parentindex: parentindex, subindex: subindex },
  });

};
export const onAddValue = (id, index, field, value) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_VALUE,
    payload: { id: id, index: index, field: field, value: value },
  });
};
export const onAddTimeCodeSubValue = (id, parentindex, subindex, field, value) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_VALUE_TIMECODE_ADDITIONAL,
    payload: { id: id, parentindex: parentindex, subindex: subindex, field: field, value: value },
  });
};
export const onSetCueSubTimeCode = (id, parentindex, subindex, field, value) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_TIMECODE_ADDITIONAL,
    payload: { id: id, parentindex: parentindex, subindex: subindex, field: field, value: value },
  });
};
export const onAddTimeCode = (id, index, field, value) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_TIMECODE,
    payload: { id: id, index: index, field: field, value: value },
  });
};
export const onSetInvalidTimeCode = (id, index, field, value, message) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_INVALID_TIMECODE,
    payload: { id: id, index: index, field: field, value: value, message: message },
  });
};
export const onsetInvalidChildTimeCode = (id, field, value, message, parentindex, subindex,) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_INVALID_TIMECODE_CHILD,
    payload: { id: id, field: field, value: value, message: message, parentindex: parentindex, subindex: subindex },
  });
};
export const onSaveData = (id, index, field, value) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_DATA,
    payload: { id: id, index: index, field: field, value: value },
  });
};

export const onSaveSuccess = (items) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_SUCCESS,
    payload: items,
  });
};
export const sortbyTrackTitle = () => (dispatch) => {
  const {
    cueSheetFormContentNeo: { selectedItem, items }
  } = store.getState();

  dispatch({
    type: actionTypes.SORT_BY_TRACKTITLE,
  });


};
export const sortbyTimeCode = () => (dispatch) => {
  const {
    cueSheetFormContentNeo: { selectedItem, items }
  } = store.getState();

  dispatch({
    type: actionTypes.SORT_BY_TIMECODE,
  });


};
export const reSortbyTimeCode = () => (dispatch) => {
  const {
    cueSheetFormContentNeo: { selectedItem, items }
  } = store.getState();

  dispatch({
    type: actionTypes.RE_SORT_TIMECODE,
  });



};
export const reSortbyTimeCodeUpdateDone = () => (dispatch) => {
  dispatch({
    type: actionTypes.RE_SORT_TIMECODE_UPDATE_DONE,
  });



};

export const saveData = (message, items, sessionid, done = null) => async (dispatch) => {

  dispatch({
    type: actionTypes.SAVING_DATA,
    payload: message,
  });


  const tId = uuidv4();


  axios
    .post(`/neocuesheet/cuesheetContent/save`, items, {
      headers: {
        tid: tId,
        sessionid: localStorage.getItem('sessionid') || sessionid,
        workspaceid: localStorage.getItem('workspaceid'),
        usertoken: localStorage.getItem('neo_id_token')
      },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK,
        payload: items
      });
      console.log("aaaaaaaaaaaaaaaaaaaaa", res);
      if (done) done(res.data && res.data.createdIds ? res.data.createdIds : false, null);


      //}
    })
    .catch((err) => {
      let trackErrors = null;
      if (err.response?.data?.e && err.response?.data?.e.indexOf("{") !== -1 && err.response?.data?.e.substring(err.response?.data?.e.indexOf("{"))) {
        let errObj = err.response?.data?.e.substring(err.response?.data?.e.indexOf("{"));
        if (JSON.parse(errObj)) trackErrors = JSON.parse(errObj);
      }
      dispatch({
        type: actionTypes.POST_ERROR,
        message: "Error in saving or updating. please retry",
        payload: err.response?.data?.e || {
          e: err.message
            ? err.message
            : "Error in saving or updating. please retry",
        },
        trackErrors: trackErrors
      });
      if (done) done(null, err.response?.data?.e ? err.response?.data?.e : err.message
        ? err.message
        : "Error linking cue sheet. please retry");
    });
};

export const saveDataLocal = (message, items, sessionid, done = null) => async (dispatch) => {

  dispatch({
    type: actionTypes.SAVING_DATA_LOCAL,
    payload: message,
  });


  const tId = uuidv4();


  axios
    .post(`/neocuesheet/cuesheetContent/savelocal`, items, {
      headers: {
        tid: tId,
        sessionid: localStorage.getItem('sessionid') || sessionid,
        workspaceid: localStorage.getItem('workspaceid'),
        usertoken: localStorage.getItem('neo_id_token')
      },
    })
    .then((res) => {
      //if (res.data.tid === tId) {
      dispatch({
        type: actionTypes.POST_OK_LOCAL,
        payload: items
      });
      if (done) done(res.data == 1 ? true : false, null);


      //}
    })
    .catch((err) => {
      dispatch({
        type: actionTypes.POST_ERROR_LOCAL,
        // payload: { e: err },
        payload: err.response?.data?.e || {
          e: err.message
            ? err.message
            : "Error in saving or updating. please retry",
        },
      });

      if (done) done(null, err);
    });
};

export const getCFTrackData = (cfId, track, done = null) => (dispatch) => {

  const {
    user: {
      credentials: { orgID },
    },
  } = store.getState();
  const tId = uuidv4();

  dispatch({
    type: actionTypes.LOADING_CFTRACKS,
  });

  axios
    .post(`${orgID}/mllic/formcontent/tracks`, { cfId: cfId, tracks: [track] }, {
      headers: { tid: tId, orgid: orgID },
    })
    .then((res) => {
      dispatch({
        type: actionTypes.LOAD_CFTRACKS,
        payload: {
          cfId: cfId,
          trackId: track,
          cfTrackData: (res.data && res.data.length > 0 ? res.data[0] : {})
        }
      });
      if (done) done(res.data, null);
    })
    .catch((err) => {

    });
};

